import { render } from "./HeaderSection.vue?vue&type=template&id=64971d3d&scoped=true"
import script from "./HeaderSection.vue?vue&type=script&lang=js"
export * from "./HeaderSection.vue?vue&type=script&lang=js"

import "./HeaderSection.vue?vue&type=style&index=0&id=64971d3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64971d3d"]])

export default __exports__